import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
/**
 * addToCart : call the custom event "cartUpdate"
 * @param  {eventTarget} eventTarget for prevent
 */

export function addToCart(form, eventTarget) {
  eventTarget.preventDefault();
  var listProducts = [];
  var requestQuantity = form.querySelector('input[name="quantity"]') ? form.querySelector('input[name="quantity"]').value : 1;
  form.querySelectorAll(".js-atc-list__item").forEach(function (item) {
    var defaultQuantity = item.querySelector('input[name="defaultQuantity"]') ? item.querySelector('input[name="defaultQuantity"]').value : 1;
    listProducts.push({
      quantity: defaultQuantity * requestQuantity,
      reflm: item.querySelector('input[name="reflm"]').value,
      offerId: item.querySelector('input[name="offerId"]').value,
      contextCode: item.querySelector('input[name="contextCode"]').value
    });
  });
  this.cartUpdate({
    listProducts: listProducts
  });
}
export function initAddToCart(form) {
  if (form) {
    import(/* webpackChunkName: "Forms" */"@mozaic-ds/freemarker/js/modules/_forms.js").then(function (module) {
      return new module.Formulaire(form);
    })["catch"](console.error);
    import(/* webpackChunkName: "CoreForms" */"integration-web-core--socle/js/assets/modules/_forms.js").then(function (module) {
      return new module.Formulaire(form);
    })["catch"](console.error);
  }
}